'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  NONE: 'none',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3JjL0ludGVudC5qcyJdLCJuYW1lcyI6WyJOT05FIiwiU1VDQ0VTUyIsIldBUk5JTkciLCJEQU5HRVIiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlO0FBQ2JBLFFBQU0sTUFETztBQUViQyxXQUFTLFNBRkk7QUFHYkMsV0FBUyxTQUhJO0FBSWJDLFVBQVE7QUFKSyxDIiwiZmlsZSI6IkludGVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgTk9ORTogJ25vbmUnLFxuICBTVUNDRVNTOiAnc3VjY2VzcycsXG4gIFdBUk5JTkc6ICd3YXJuaW5nJyxcbiAgREFOR0VSOiAnZGFuZ2VyJ1xufVxuIl19